export default {
  name: 'evaluate-answer-list',
  created () {
    if (document.referrer.indexOf('edit') !== -1) {
      this.stepUpUser = this.$route.query.answer.step_up_user
      this.answerContent = this.$route.query.answer.answer_content
    } else {
      this.search()
    }
  },
  data () {
    return {
      isAllAnswer: false,
      stepUpUser: null,
      normalAnswers: [],
      personnelAnswers: [],
      businessAnswers: []
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      let data = {
        id: this.$route.params.id
      }

      let res = await this.$store.dispatch('EVALUATE_ANSWER_ANSWER_DETAIL_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpUser = res.step_up_user
      this.normalAnswers = res.evaluate_normal_answer
      this.personnelAnswers = res.evaluate_personal_answer.data
      this.businessAnswers = res.evaluate_business_answer.data
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goEvaluateAnswerEdit: function () {
      const evaluateAnswerId = this.$route.params.id
      this.$router.push({ path: '/evaluate_answer/' + evaluateAnswerId + '/edit' })
    },

    async updateAnswers () {
      let data = {
        answerContent: this.answerContent
      }
      await this.$store.dispatch('STEPUP_ANSWER_UPDATE', {id: this.$route.params.step_up_answer_id, data: data})
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal()
    },
    selectedStyle: function (index, radioVal) {
      if (this.answerContent[index].answer_content == radioVal) {
        return true
      }
      return false
    },
    isAllAnswerQuestion: function () {
      for (let i = 0; i < this.answerContent.length; i++) {
        if (this.answerContent[i].answer_content != 0) {
          this.isAllAnswer = true
        } else {
          this.isAllAnswer = false
          return
        }
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    stepupSendModal: function () {
      const button = document.getElementById('stepupSendModalButton')
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-answer-list.js